import Select, { ISelectParameterProperty } from '../../InputModels/Select';
import Combobox, { IComboboxParameterProperty } from '../../InputModels/Combobox';
import ComboboxMultiSelectFormModel from '../../InputModels/ComboboxMultiSelect/ComboboxMultiSelectFormModel';
import Multicheckbox, { IMulticheckboxParameterProperty } from '../../InputModels/Multicheckbox';
import FileInput from '../../InputModels/FileInput';
import DateRange from '../../InputModels/DateRange/DateRange';
import RadioGroup from '../../InputModels/RadioGroup/RadioGroup';
import Common from '../../InputModels/Common';
import ImageUpload from '../../InputModels/ImageUpload/ImageUpload';
import FieldSet from '../../InputModels/FieldSet/FieldSet';
import { IParameterProperty } from '../../../../../../types/IParameter';
import RichText from '../../InputModels/RichText/RichText';
import Checkbox from '../../InputModels/Checkbox/Checkbox';

import { InputType } from '../../../InputTypes';

export default function getParameterForType(parameter: IParameterProperty, inputs: IParameterProperty[] | null = null) {
  switch (parameter.type) {
    case InputType.CHECKBOX:
      return new Checkbox(parameter as any);
    case InputType.SELECT:
      return new Select(parameter as ISelectParameterProperty);
    case InputType.COMBOBOX:
      return new Combobox(parameter as IComboboxParameterProperty);
    case InputType.COMBOBOXMULTISELECT:
      return new ComboboxMultiSelectFormModel(parameter);
    case InputType.MULTICHECKBOX:
      return new Multicheckbox(parameter as IMulticheckboxParameterProperty);
    case InputType.FILE:
      return new FileInput(parameter);
    case InputType.IMAGEUPLOAD:
      return new ImageUpload(parameter);
    case InputType.FIELDSET:
      return new FieldSet(parameter);
    case InputType.DATERANGE:
      return new DateRange(parameter);
    case InputType.RADIO:
      return new RadioGroup(parameter, inputs);
    case InputType.RICHTEXT:
      return new RichText(parameter);
    case InputType.HIDDEN:
    case InputType.NUMBER:
    case InputType.TEXT:
    case InputType.TEXTAREA:
    case InputType.DATE:
    case InputType.DATETIME_LOCAL:
    case InputType.PASSWORD:
    case InputType.SUBMIT:
    case InputType.SORTABLELIST:
    default:
      return new Common(parameter);
  }
}

export function parametersContainTypeFile(parameters: IParameterProperty[] | Record<string, IParameterProperty>) {
  if (Array.isArray(parameters)) {
    return parameters.some(parameter => parameter.type === InputType.FILE || parameter.type === InputType.IMAGEUPLOAD);
  }

  if (typeof parameters === 'object') {
    return Object.values(parameters).some(
      parameter => parameter.type === InputType.FILE || parameter.type === InputType.IMAGEUPLOAD
    );
  }

  return false;
}
